const TimeLeft = () => {
  return (
    <div className="flex justify-center">
      <img className="w-full" src="/assets/AnimatedTimer.png" alt="timer" />
    </div>
  );
};

export default TimeLeft;
